import React from 'react'
import './theme.scss'

export default function Panel({ children }) {
    return <div className="panel">{children}</div>
}
